import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["animation", "children", "onEntered", "dangerouslySetInnerHTML"],
  _excluded2 = ["transitionWrapper"];
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
function ownKeys(e, r) {
  var t = _Object$keys(e);
  if (_Object$getOwnPropertySymbols) {
    var o = _Object$getOwnPropertySymbols(e);
    r && (o = _filterInstanceProperty(o).call(o, function (r) {
      return _Object$getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React, { useCallback, useMemo } from "react";
import isFunction from "lodash/isFunction";
import PropTypes from "prop-types";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { log } from "@jutro/logger";
import { animationDelayDefault, resolveAnimationFromName } from "../config/animationMap";
import styles from "./AnimationGroup.module.css";
var animationGroupPropTypes = {
  animation: PropTypes.oneOf(["expand", "insert", "highlight", "reveal"]),
  className: PropTypes.string,
  children: PropTypes.node
};
export var AnimationGroup = function (_ref) {
  var animation = _ref.animation,
    children = _ref.children,
    onEntered = _ref.onEntered,
    other = (_ref.dangerouslySetInnerHTML, _objectWithoutProperties(_ref, _excluded)),
    animationProps = useMemo(function () {
      var animationConfig = resolveAnimationFromName(animation);
      return isFunction(animationConfig) ? animationConfig() : animationConfig;
    }, [animation]),
    onEnteredCallback = useCallback(function (node, isAppearing) {
      node.style = _objectSpread(_objectSpread({}, node.style), {}, {
        height: "auto"
      }), null == onEntered || onEntered(node, isAppearing);
    }, [onEntered]);
  animation && !animationProps && (log.warning("Unable to find animation alias for '".concat(animation, "'. Using default properties.")), animationProps = {
    classNames: animation,
    timeout: animationDelayDefault
  });
  var appearClasses,
    combinedProps = _objectSpread(_objectSpread(_objectSpread({}, animationProps), other), {}, {
      onEntered: onEnteredCallback
    }),
    classNames = combinedProps.classNames,
    enterClasses = {
      enter: styles["".concat(classNames, "_enter")],
      enterActive: styles["".concat(classNames, "_enter_active")]
    },
    exitClasses = {
      exit: styles["".concat(classNames, "_exit")],
      exitActive: styles["".concat(classNames, "_exit_active")]
    };
  combinedProps.appear && (appearClasses = {
    appear: styles["".concat(classNames, "_enter")],
    appearActive: styles["".concat(classNames, "_enter_active")]
  }), combinedProps.classNames = _objectSpread(_objectSpread(_objectSpread({}, enterClasses), exitClasses), appearClasses);
  var transitionGroup,
    transitionWrapper = combinedProps.transitionWrapper,
    groupProps = _objectWithoutProperties(combinedProps, _excluded2);
  if (React.Children.count(children) > 1) {
    var _context,
      childTransitions = _mapInstanceProperty(_context = React.Children).call(_context, children, function (child) {
        return React.createElement(CSSTransition, groupProps, child);
      });
    transitionGroup = React.createElement(TransitionGroup, null, childTransitions);
  } else transitionGroup = React.createElement(CSSTransition, groupProps, React.createElement("span", null, children));
  if (transitionWrapper) {
    var wrapperClass = styles[transitionWrapper];
    return React.createElement("div", {
      className: wrapperClass
    }, transitionGroup);
  }
  return transitionGroup;
};
AnimationGroup.propTypes = animationGroupPropTypes, AnimationGroup.__docgenInfo = {
  description: "Defines an Animation Group.\nThis wraps TransitionGroup/CSSTransition and provides support for animation aliases to define transition properties.\nThe animations are triggered when elements are added to or removed from the children of the animation group.\nFor the 'swap' type animations where you are replacing one element with another, each element requires a unique\n'key' to trigger the animation.\n\nProperties: {@link AnimationGroup.propTypes}\n\n@see https://github.com/reactjs/react-transition-group\n\n@example <AnimationGroup animation=\"reveal\">{ children to animate }</AnimationGroup>",
  methods: [],
  displayName: "AnimationGroup",
  props: {
    animation: {
      type: {
        name: "enum",
        value: [{
          value: "'expand'",
          computed: !1
        }, {
          value: "'insert'",
          computed: !1
        }, {
          value: "'highlight'",
          computed: !1
        }, {
          value: "'reveal'",
          computed: !1
        }]
      },
      required: !1,
      description: "Optional animation name/alias"
    },
    className: {
      type: {
        name: "string"
      },
      required: !1,
      description: "Optional css class(es) to add to the grid element"
    },
    children: {
      type: {
        name: "node"
      },
      required: !1,
      description: "Children, preferably 'Row'"
    }
  }
}, AnimationGroup.__docgenInfo = {
  componentName: "AnimationGroup",
  packageName: "@jutro/components",
  description: "Defines an Animation Group.\nThis wraps TransitionGroup/CSSTransition and provides support for animation aliases to define transition properties.\nThe animations are triggered when elements are added to or removed from the children of the animation group.\nFor the 'swap' type animations where you are replacing one element with another, each element requires a unique\n'key' to trigger the animation.\n\nProperties: {@link AnimationGroup.propTypes}",
  displayName: "AnimationGroup",
  methods: [],
  actualName: "AnimationGroup",
  props: {
    animation: {
      type: {
        name: "enum",
        value: [{
          value: "'expand'",
          computed: !1
        }, {
          value: "'insert'",
          computed: !1
        }, {
          value: "'highlight'",
          computed: !1
        }, {
          value: "'reveal'",
          computed: !1
        }]
      },
      required: !1,
      description: "Optional animation name/alias"
    },
    className: {
      type: {
        name: "string"
      },
      required: !1,
      description: "Optional css class(es) to add to the grid element"
    },
    children: {
      type: {
        name: "node"
      },
      required: !1,
      description: "Children, preferably 'Row'"
    }
  }
};